import { preventDefault, registerView, View, ViewComponent } from "@frui.ts/views";
import { observer, Observer } from "mobx-react-lite";
import * as React from "react";
import { Alert, Button, Col, Form } from "react-bootstrap";
import ChargeManagementViewModel from "../../viewModels/chargeManagement/chargeManagementViewModel";
import LoadingModal from "views/common/loadingModal/loadingModal";
import ErrorCard from "views/common/error/errorCard";
import AuthCodeInput from "../common/authCodeInput/authCodeInput";
import { useCallback } from "react";

const ChargeManagementView: ViewComponent<ChargeManagementViewModel> = observer(({ vm }) => {
  const formRef = useCallback(node => {
    if (node !== null) {
      vm.formElement = node;
    }
  }, []);

  if (vm.activeChild) {
    return <Observer>{() => <View vm={vm.activeChild} />}</Observer>;
  }

  const tg = (code: string) => vm.localizationService.translateGeneral(`chargeManagement.${code}`);
  const translate = (code: string) => vm.localizationService.translateAttribute("charge", code);
  const getCurrentLanguageUrl = () => {
    const currentLang = document.documentElement.lang;
    const langMap: { [key: string]: string } = {
      "en-GB": "en",
      "de-DE": "de",
      "cs-CZ": "cs",
      en: "en",
      de: "de",
      cs: "cs",
    };

    const mappedLang = langMap[currentLang] || currentLang?.split("-")[0];

    if (mappedLang && mappedLang !== "cs") {
      return `/${mappedLang}/`;
    }
    return "/";
  };
  return (
    <div className="bg-white p-3 p-lg-4 p-xl-7 rounded">
      <Form ref={formRef} onSubmit={preventDefault(vm.verifyCharge)} className="p-3 p-lg-4 p-xl-7">
        <h3>{tg("title")}</h3>
        {vm.errorMessage && <ErrorCard message={vm.errorMessage} />}
        <View vm={vm.vehicleInfoViewModel} />
        <Form.Row className="align-items-start">
          <AuthCodeInput target={vm.vignette} property="authCode" translate={translate} />
          <Form.Group as={Col} sm={12} xl={6}>
            <Alert variant="info" className="mt-3 mt-xl-5 mb-0 py-2 border-none w-100">
              <Form.Label className="mb-0">{translate("authorizationCodeTooltip")}</Form.Label>
            </Alert>
          </Form.Group>
        </Form.Row>
        <View vm={vm.turnstileViewModel} />
        <div className="d-flex flex-column-reverse flex-md-row align-items-center justify-content-center mx-auto mx-md-10">
          <a className="btn-block d-block mt-3 mr-md-2 mb-2 mb-lg-0 mw-100 btn btn-light" href={getCurrentLanguageUrl()}>
            {tg("leave")}
          </a>
          <Button
            disabled={!vm.turnstileViewModel.turnstileToken || vm.turnstileViewModel.isDisabledByTurnsitel}
            type="submit"
            className="btn-block d-block mt-3 mb-2 mb-lg-0 ml-md-2 mw-100">
            {tg("validateCharge")}
          </Button>
        </div>
        <LoadingModal translate={vm.translate} isVisible={vm.busyWatcher.isBusy} />
      </Form>
    </div>
  );
});

registerView(ChargeManagementView, ChargeManagementViewModel);
